import { IconProps } from "./HomeIcon";

const CloseIcon = ({ color = "#999999" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.31818 18.1451C3.89394 18.5694 3.89394 19.2572 4.31818 19.6814C4.74243 20.1057 5.43026 20.1057 5.85451 19.6814L12 13.536L18.1455 19.6815C18.5697 20.1057 19.2576 20.1057 19.6818 19.6815C20.106 19.2572 20.106 18.5694 19.6818 18.1451L13.5363 11.9996L19.6814 5.85451C20.1057 5.43026 20.1057 4.74243 19.6814 4.31818C19.2572 3.89394 18.5694 3.89394 18.1451 4.31818L12 10.4633L5.85487 4.3182C5.43063 3.89396 4.74279 3.89396 4.31855 4.3182C3.89431 4.74244 3.8943 5.43028 4.31855 5.85452L10.4637 11.9996L4.31818 18.1451Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
